import { render } from "./AppointmentPriority.vue?vue&type=template&id=3272d6ca"
import script from "./AppointmentPriority.vue?vue&type=script&lang=js"
export * from "./AppointmentPriority.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__